export { default as HandSolidIcon } from './HandSolidIcon';
